import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Models } from '@ibexfusion/models';
import { HttpClient } from '@angular/common/http';

import { PageAction } from '../../../components/page-actions/page-actions.component';
import { ImportLogsService } from '@services/import-logs/import-logs.service';
import { ImportService } from '@services/imports/import.service';
import { ImportTypeService } from '@services/import-types/import-type.service';
import { EnvironmentService } from '@services/environment/environment.service';

@Component({
    selector: 'app-import-logs-detail',
    templateUrl: './import-logs-detail.component.html',
    styleUrls: ['./import-logs-detail.component.scss'],
    providers: [ImportLogsService, ImportService, ImportTypeService],
    standalone: false
})
export class ImportLogsDetailComponent implements OnInit {

  public importLog: Models.ImportLog;

  public jsonLog: any;

  public pageActions: PageAction[];

  public compositions: any[];

  public isLoading = false;

  public title;
  public subtitle;

  public importId: string = null;

  public importTypeId: string = null;

  public type = 'import';

  constructor(
    public importLogsService: ImportLogsService,
    public importService: ImportService,
    public importTypeService: ImportTypeService,
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private environmentService: EnvironmentService
  ) {
  }

  ngOnInit() {
    if (this.route && this.route.snapshot && this.route.snapshot.data && this.route.snapshot.data.type) {
      this.type = this.route.snapshot.data.type;
    }
    this.isLoading = true;
    this.title = 'Log JSON: ';
    this.importLogsService.get(this.route.snapshot.params['id']).then(response => {
      this.importLog = response;
      this.importId = response.importId;
      this.importTypeId = response.importTypeId;
      this.importService.get(this.importId).then(responseImport => {
        this.importTypeService.get(this.importTypeId).then(responseImportType => {
          this.title = 'Log of Importer: ' + responseImport.title;
          this.subtitle = 'Import Type: ' + responseImportType.title;
        });
      });

      return this.http.get(this.environmentService.getLogFileRequestUrl() + this.importLog.logFileURL).subscribe(responseJSON => {
        this.jsonLog = responseJSON;
      });
    });
    this.createPageActions();
    this.isLoading = false;
  }

  private createPageActions(): void {
    if (this.type === 'import') {
      this.pageActions = [
        new PageAction({
          icon: 'subdirectory_arrow_left',
          title: 'Go to Importer',
          callback: () => {
            this.router.navigate(['imports/', this.importId]);
          }
        }),
        new PageAction({
          icon: 'subdirectory_arrow_left',
          title: 'Go to Importer Type',
          callback: () => {
            this.router.navigate(['import-types/', this.importTypeId]);
          }
        })
      ];
    } else {
      this.pageActions = [
        new PageAction({
          icon: 'subdirectory_arrow_left',
          title: 'Back to package',
          callback: () => {
            this.router.navigate(['packages/', this.importId]);
          }
        })
      ];
    }
  }
}
